import React from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import postal from 'postal';

import Loading from '../../../../shared/loading';
import ErrorBoundary from '../../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import Validator from '../../../../shared/validator';
import { editorValidate } from '../channel-editor-postal';
import assignWireCategory from '../../../../services/wire/category-service';
import { getAllCategories } from '../../../../services/categories-service';

const GroupLabel = ({ label }) => <div>{label}</div>;
GroupLabel.propTypes = { label: PropTypes.string.isRequired };

export default class CategoriesControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    categoryId: PropTypes.number,
  }

  static defaultProps = {
    categoryId: null,
  }

  constructor(props, context) {
    super(props, context);

    this.validator = new Validator({
      categoryRequired: state => !!state.assignedCategory,
    });

    this.state = {
      category: null,
      categories: [],
      assignedCategory: null,
      validations: this.validator.getValidations(),
    };

    editorValidate(this, 'category');
    editorValidate(this, 'category', { topic: 'validate.category' });

    this.assignCategory = this.assignCategory.bind(this);
  }

  componentDidMount() {
    this.loading.start();

    getAllCategories()
      .then(result => {
        const categories = result.data.categories.map(category => ({
          value: category.id,
          label: category.name,
        }));
        const { categoryId } = this.props;

        if (categoryId) {
          const category = categories.find(cat => cat.value === categoryId);
          this.setState({ categories, category, assignedCategory: category });
        } else {
          this.setState({ categories });
        }
      })
      .catch(error => defaultOnErrorHandler(error, 'Error getting categories'))
      .finally(() => this.loading.stop());
  }

  assignCategory(category) {
    this.loading.start();
    const currentCategory = this.state.category;
    const assignedCategory = category;

    this.setState({ category });

    assignWireCategory(this.props.wireId, category.value)
      .then(() => {
        this.setState(state => {
          state.assignedCategory = assignedCategory;
          state.validations = this.validator.validateForm(state);
          return state;
        });
        postal.publish({
          channel: 'editor',
          topic: 'category-changed',
          data: category ? category.label : null,
        });
      })
      .catch(error => {
        this.setState({ category: currentCategory });
        defaultOnErrorHandler(error, `Error assigning category: ${category.name}`);
      })
      .finally(() => this.loading.stop());
  }

  render() {
    const groupedOptions = [
      {
        label: 'select a category',
        options: this.state.categories,
      },
    ];

    return (
      <ErrorBoundary>
        <aside className="sidebar-item">
          <Loading variant="inline" ref={el => (this.loading = el)}>
            <section className={`form-group category-control ${this.state.validations.formValid ? '' : 'has-error'}`}>
              <Select
                className="select-container"
                classNamePrefix="select"
                value={this.state.category}
                onChange={this.assignCategory}
                options={groupedOptions}
                formatGroupLabel={GroupLabel}
                components={{
                  Placeholder: props => (
                    <components.Placeholder {...props}>
                      <div className="select__placeholder">
                        <span>{groupedOptions[0].label}</span>
                        <span className="mandatory">*</span>
                      </div>
                    </components.Placeholder>
                  ),
                }}
              />
              {this.state.validations.categoryRequiredValid || <span className="help-block">Please select a category for your wire.</span>}
            </section>
          </Loading>
        </aside>
      </ErrorBoundary>
    );
  }
}
